import { TagButton } from "./TagButton";
import { useEffect, useState } from "react";
import { Decimal } from "@liquity/lib-base";
import { isEmpty } from 'lodash'

type Props = {
  label: string;
  amount: string;
  setEditedAmount: (editedAmount: string) => void;
  unit?: string;
  usdValue?: string;
  balance?: string;
  maxAmount?: string;
  icon?: string
};

export const InputField: React.FC<Props> = ({
  label,
  amount,
  usdValue,
  unit,
  balance,
  setEditedAmount,
  maxAmount,
  icon,
}) => {
  const [val, setVal] = useState("")
  useEffect(() => {
    const formatedAmount = isEmpty(amount) ? "" : Number(amount).toString()
    setVal(formatedAmount)
  }, [amount]);

  return (
    <div className="mt-6">
      <div className="text-style-label mb-3">{label}</div>
      <div className="bg-card border-card flex flex-col py-5 px-4">
        <div className="flex flex-row justify-between">
          <div className="flex flex-row justify-start">
            <input
              type="number"
              value={val}
              onChange={e => {
                try {
                  setEditedAmount(e.target.value)
                } catch {
                  if (isEmpty(e.target.value)) {
                    setVal("")
                  }
                }
              }}
              className="text-style-value bg-inherit outline-none appearance-none"
            />
            {usdValue && <div className="text-style-sub ml-2">(${usdValue})</div>}
          </div>
          <div className="flex flex-row justify-end">
            <div className="flex flex-row">
              {icon && (
                <img src={icon} alt={unit} className="w-6 h-6"/>
              )}
              {!!unit && (
                <div className="text-style-attr ml-2.5">{unit}</div>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-row items-center">
          {balance && (
            <div className="flex flex-row text-style-sub">
            Wallet:
            <div className="ml-1 text-style-plain">
              {balance} <span>{unit}</span>
            </div>
          </div>
          )}
          {maxAmount && (
            <TagButton
              label="MAX"
              disabled={false}
              onClick={() => {
                setVal(Decimal.from(maxAmount).toString(4))
                setEditedAmount(maxAmount)
              }}
              className="ml-2"
            />
          )}
        </div>
      </div>
    </div>
  )
};
